/**
 * 评测注入
 */
import Webmsc from '@/web-api/sndmsc'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      sndmscIns: null,
      // 播放按钮
      showButtonPlay: false,
      // 暂停按钮
      showButtonPause: false,
      // 结束评测按钮
      showButtonStopRecord: false,
      // 开始评测按钮
      showButtonRecord: false,
      // 加载中按钮
      showButtonLoading: false,
      // 波形图
      showWaveform: false,
      // 倒计时提示文字
      countdownText: '',
      // 录音加载、踩点中文字提示文字
      loadingText: '',
      //录音倒计时
      recordingCountdownTimer: null,
      countdownVal: 0,
    }
  },
  created() {
    this.__init()
    this.$once('hook:destroyed', () => {
      console.log('hook:destroyed')
      this.sndmscIns && this.sndmscIns.destroy()
      this.cefHtppIns && this.cefHtppIns.destroy()
      this.sndmscIns = null
      this.clearRecordingTimer()
    })
  },
  computed: {
    ...mapGetters(['currentUser']),
  },
  activated() {
    if (!this.sndmscIns) {
      this.__init()
    }
    this.$once('hook:deactivated', () => {
      console.log('hook:deactivated')
      this.sndmscIns && this.sndmscIns.destroy()
      this.cefHtppIns && this.cefHtppIns.destroy()
      this.sndmscIns = null
      this.clearRecordingTimer()
    })
  },
  methods: {
    __init() {
      if (this.sndmscIns != null) return
      this.__webSndInit()
    },
    __webSndInit() {
      this.sndmscIns = new Webmsc({
        record_begin_callbcak: this.record_begin_callbcak,
        evalute_callback: this.evalute_callback,
        error_callback: res => {
          if (this.sndmscIns == null || this.sndmscIns.state == 'destroy') {
            return
          }
          let msg = this.$t('common_text_none_network')
          this.clearRecordingTimer()
          if (this.sndmscIns.state != 'stop') {
            layer.msg(msg)
            // layer.alert(`${msg}${res.code}`)
          } else {
            layer.open({
              type: 0,
              title: '',
              content: this.$t('common_text_server_error'),
              btn: [
                this.$t('button_common_start_over'),
                this.$t('button_common_cancel'),
              ],
              closeBtn: 0,
              yes: (index, layero) => {
                layer.close(index)
                this.sndmscIns.retry()
              },
              btn2: (index, layero) => {
                layer.close(index)
                this.$router.back()
              },
            })
            return
          }
          this.snd_error_notity({
            errorMsg: res.message || res.type,
            errorCode: res.code,
            sid: res.sid,
          })
        },
      })
      this.sndmscIns.init().catch(res => {
        let title = res.title || false
        let msg = res.message
        layer.alert(
          msg,
          {
            title: title,
            closeBtn: false,
            move: '.layui-layer-content',
            btn: ['ok'],
          },
          index => {
            layer.close(index)
            this.$router.back()
          }
        )
      })
    },
    // __sndInit() {
    //   console.log('init int')
    //   this.sndmscIns = new sndmsc({
    //     domId: 'waveform',
    //     evalute_callback: data => {
    //       this.evalute_callback({
    //         data: data
    //       })
    //     },
    //     record_begin_callbcak: () => {
    //       this.record_begin_callbcak()
    //     },
    //     error_callback: data => {
    //       try {
    //         if (data.indexOf('设备中断') != -1) {
    //           layer.msg(this.$t('layer_common_notfoundmic'))
    //           return
    //         }
    //         this.clearRecordingTimer()
    //         let errData = JSON.parse(data)
    //         if (errData.errorCode == 10118) {
    //           layer.alert(this.$t('layer_common_notfoundmic'), {
    //             title: '',
    //             closeBtn: 0,
    //             btn: [this.$t('button_common_ok')]
    //           }, () => {
    //             this.$router.back()
    //           })
    //           return
    //         }
    //         this.sndmscIns.stop()
    //         if (errData.flag == 2) {
    //           layer.msg(this.$t('evaluate_common_training_fail'))
    //           this.snd_error_notity(errData)
    //         }
    //       } catch (e) {
    //         console.log(e)
    //       }
    //     },
    //     retry_callbcak: data => {
    //       let errData = JSON.parse(data)
    //       if (errData.code !== 0) {
    //         this.snd_error_notity(errData)
    //       }
    //     },
    //     energy_callback: this.energy_callback
    //   })

    //   this.cefHtppIns = new CyStorage({
    //     //注册上传失败事件
    //     upload_notify: data => {
    //       const upResult = JSON.parse(data)
    //       if (upResult.hasOwnProperty('flag') && upResult.flag !== 0) {
    //         layer.msg(this.$t('evaluate_common_training_fail'))
    //         this.upload_notify(upResult)
    //       }
    //     },
    //     //注册上传进度
    //     upload_progress_notify: data => {
    //       var upResult = JSON.parse(data)
    //       if (upResult.errcode !== 0) {
    //         //失败
    //         this.upload_notify()
    //       } else {
    //         this.upload_progress_notify(upResult)
    //       }
    //     }
    //   })
    //   this.cefHtppIns.init(function () {})
    //   this.sndmscIns.init(function () {})
    // },
    energy_callback() {},
    evalute_callback(res) {},
    error_notity() {},
    snd_error_notity(error) {},
    record_begin_callbcak(e) {},
    cancelRecord() {
      this.clearRecordingTimer()
      this.showWaveform = false
      this.sndmscIns.cancel && this.sndmscIns.cancel()
    },
    /**
     * 录音倒计时
     */
    clearRecordingTimer() {
      clearInterval(this.recordingCountdownTimer)
      this.recordingCountdownTimer = null
    },
    recordingTimeInterval(cb, time) {
      if (time == null) return
      if (time == -1) {
        time = this.countdownVal
      } else {
        //保存时间，供暂停后使用
        this.countdownVal = time
      }
      this.countdownText =
        this.$t('evaluate_common_training_remain') + time + 's'
      // 兼容自主命题
      this.$emit('setCountdownText', this.countdownText)
      if (this.recordingCountdownTimer) {
        this.clearRecordingTimer()
      }
      this.recordingCountdownTimer = setInterval(() => {
        try {
          time--
          this.countdownText =
            this.$t('evaluate_common_training_remain') + time + 's'
          // 兼容自主命题
          this.$emit('setCountdownText', this.countdownText)
          this.countdownVal = time
          if (time <= 0) {
            this.countdownText = ''
            // 兼容自主命题
            this.$emit('setCountdownText', this.countdownText)
            this.clearRecordingTimer()
            cb && cb()
          }
        } catch (e) {
          this.clearRecordingTimer()
        }
      }, 1000)
    },
    deviceError(data) {
      if (data.indexOf('无录音设备') != -1 || data.indexOf('设备中断') != -1) {
        layer.alert(
          this.$t('layer_common_notfoundmic'),
          {
            title: '',
            closeBtn: 0,
            btn: [this.$t('button_common_ok')],
          },
          () => {
            this.$router.back()
          }
        )
        return true
      } else {
        return false
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    this.sndmscIns && this.sndmscIns.destroy()
    this.cefHtppIns && this.cefHtppIns.destroy()
    this.sndmscIns = null
    this.clearRecordingTimer()
    next()
  },
}
